import { Dispatch, SetStateAction } from "react";

export const handleImages = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any --- hack to extract images from smash-ballon
  images: any,
  initialCount: number,
  imageCount: number,
  loadCount: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any --- hack to extract images from smash-ballon
  setImages: Dispatch<SetStateAction<any[]>>,
) => {
  const startingCount =
    imageCount === 0 ? 0 : initialCount + imageCount - loadCount;
  const endingCount =
    imageCount === 0 ? initialCount - 1 : initialCount - 1 + imageCount;

  for (let i = startingCount; i <= endingCount; i++) {
    if (images?.children[i]) {
      const imageContainer = images.children[i].children[0];
      const imageBase = imageContainer.querySelector(".sbi_photo");
      const itemHref = imageBase.href;
      const imageSrc = imageBase.querySelector("img").getAttribute("src");
      const videoSrc = imageContainer
        .querySelector(".sbi_link_area.nofancybox")
        ?.getAttribute("data-video");

      imageBase.removeAttribute("href");
      imageBase.removeAttribute("target");
      imageBase.removeAttribute("rel");

      let img: { src: string; alt: string } | null = null;
      for (let j = 0; j < imageBase.children.length; j++) {
        img =
          imageBase.children[j].nodeName === "IMG"
            ? imageBase.children[j]
            : null;
      }

      setImages((state) => [
        ...state,
        {
          el: img,
          href: itemHref,
          caption: img?.alt,
          src: imageSrc,
          videoSrc: videoSrc,
        },
      ]);
    }
  }
};
